import { CLOSE_DIALOG_PROMPT, SHOW_DIALOG_PROMPT } from '../constants/actions';

const DEFAULT_DIALOG_PROMPT_STATE = {
  visible: false,
  type: null,
};

const dialogPromptReducer = (state = DEFAULT_DIALOG_PROMPT_STATE, action) => {
  switch (action.type) {
    case CLOSE_DIALOG_PROMPT:
      return {
        ...state,
        visible: false,
      };
    case SHOW_DIALOG_PROMPT:
      return {
        ...state,
        visible: true,
        type: action.dialogType,
      };
    default:
      return state;
  }
};

export default dialogPromptReducer;
